<template>
  <div class="seoBox">
    <cms-wysiwyg :html="cleanHtml" />
  </div>
</template>

<script>
import CmsWysiwyg from '~/components/Cms/CmsWysiwyg';

export default {
  name: 'SeoBox',
  components: { CmsWysiwyg },
  props: {
    content: {
      type: String,
      default: '',
    },
  },
  computed: {
    cleanHtml() {
      return this.content;
      // return this.$sanitize(this.content);
    },
  },
};
</script>

<style lang="scss">
.seoBox {
  padding: 3rem 3.5rem 3.4rem;
  background-color: $cWhite;

  @include rwd('tablet') {
    padding: 3rem 2rem 3.4rem;
  }

  h2 {
    color: $cMainDark;
    margin-bottom: 3rem;
    font-size: 3.6rem;
    line-height: 4.3rem;

    @include rwd('tablet') {
      font-size: 3rem;
      line-height: 3.6rem;
      text-align: center;
    }
  }

  p {
    margin-bottom: 3.4rem;
    font-size: 1.6rem;
    line-height: 2rem;
    color: $cAddDark02;

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
